import './App.css';
import './Responsive.css';
import Routers from './routers/routers';

function App() {
  return (
    <div className="App">
      <Routers />
    </div>
  );
}

export default App;
